import { getAvailabilityAlertOptions } from "@sunner-cloud/api-client";
import { useQuery } from "@tanstack/react-query";

export const useHasActiveAlert = (enabled: boolean) =>
  useQuery({
    ...getAvailabilityAlertOptions(),
    enabled,
    select: ({ alert }) => alert !== null,
  }).data;
